// extracted by mini-css-extract-plugin
export default {"root":"BookingCategoryToggle_root__MCE4x","pill":"BookingCategoryToggle_pill__no9nH","pillActive":"BookingCategoryToggle_pillActive__Ehzy8"};